export default __webpack_public_path__ + "static/turismo-icon-f5f40f0f0b3c0eafbad94969c80a75ec.svg";